import { useMemo, useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from 'src/shadcn/components/ui/tabs-old'
import ComparisonDashboard2 from './ComparisonDashboard2'
import DemandCharges from './DemandCharges'
import { API_RESP_INIT, convertApiResponse, OriginalApiResponse } from './modules'
import OverallImpactDashboard from './OverallImpactDashboard'
import ToDRebates from './ToDRebates'
import BillComparison from './BillComparison'
import EpiechartExample from './EpiechartExample'
import TODZoneChart from './TODZoneChart'
import { useMainContext } from './MainContext'

type Props = {
    // OG_API_RESPONSE: any
}

const MYTDashboard = ({ }: Props) => {


    const { apiRespData, formData } = useMainContext()

    const DATA: any = useMemo(() => {
        if (apiRespData) {
            return convertApiResponse(apiRespData, formData)
        }
        return API_RESP_INIT
    }, [convertApiResponse, apiRespData])

    console.log({ DATA });

    const [chartSwitcher, setchartSwitcher] = useState<"units" | "amount">("units")
    return (
        <div>
            <div className="grid grid-cols-1 md:grid-flow-col md:grid-cols-6  md:grid-rows-2  xl:grid-cols-12 gap-4  border-b border-gray-300 h-[30vh]  p-2">
                <div className="md:order-1 md:col-span-2 xl:order-1 xl:col-span-2 ">
                    <div className='w-full  flex justify-center items-center  h-[150px]'>
                        <DemandCharges amount={DATA?.demandCharges?.amount || 0} />
                    </div>
                </div>
                <div className=" md:order-3 md:row-span-2  md:col-span-4 xl:order-2 xl:col-span-8">
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                        <ComparisonDashboard2 items={DATA.comparisonDashboard || []} />
                        <ToDRebates items={DATA.todRebates || []} />
                    </div>
                </div>
                <div className="md:order-2 md:col-span-2 xl:order-3 xl:col-span-2">
                    <OverallImpactDashboard {...DATA.overallImpact} />
                </div>
            </div>
            <div className='h-[50vh] grid grid-cols-2 gap-4'>
                <div>
                    <div className='flex justify-between items-center my-2'>
                        <div className='text-sm font-semibold'>Impact of Changes in ToD Tariff and Banking Provisions</div>
                        <div className=" mr-9">
                            <Tabs value={chartSwitcher} onValueChange={(e: any) => setchartSwitcher(e)} style={{ width: "100px" }}>
                                <TabsList variant={'black'}>
                                    <TabsTrigger variant={'black'} className="text-xs" value="amount">Amount</TabsTrigger>
                                    <TabsTrigger variant={'black'} className="text-xs" value="units">Units</TabsTrigger>
                                </TabsList>
                            </Tabs>
                        </div>
                    </div>
                    <div className='grid grid-cols-5 py-4'>
                        <div className='col-span-2'>
                            <EpiechartExample apiRespoData={apiRespData && apiRespData["Impact of Changes in ToD tariff and banking provisions"]} />
                        </div>
                        <div className='col-span-3'>
                            <div className=" ">
                                <TODZoneChart data={apiRespData && apiRespData['Impact of Changes in ToD tariff and banking provisions']} type={chartSwitcher} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-l border-gray-400'>
                    <div className='flex justify-between items-center my-2'>
                        <div className='text-sm font-semibold mx-4 my-2' >Bill Comparison </div>
                    </div>
                    <BillComparison data={apiRespData && apiRespData['Sample Bill Comparison']["components"]} />
                </div>
            </div>
        </div>
    )
}

export default MYTDashboard